import React, { useEffect, useRef, useState } from 'react'

import ReactModal from 'react-modal';
import { deleteGallery, loadGallery, SaveGallery } from '../utils/Network';
export default function Gallery(props) {

    const [loading, setLoading] = useState(false);
    const [title, setTitle] = useState(null);
    const [error, setError] = useState(false);
    const [gallery_images, setGalleryImages] = useState(false);
    const [count, setGalleryCount] = useState(false);
    const [gallery_pages, setGalleryPages] = useState(false);
    const [gallery_modal_is_open, setGalleryModalIsOpen] = useState(false);
    const [uploaded_image, setUploadedImage] = useState(false);
    const [file, setFile] = useState(false);
    const [filePreview, setFilePreview] = useState(null);
    const [page, setPage] = useState(1);
    const [delete_loading, setDeleteLoading] = useState(null);
    const [activeTab, setActiveTab] = useState('images');
    
    const inputFileRef = useRef(null)

    useEffect(() => {
        if (props.isOpen) {
            setGalleryModalIsOpen(props.isOpen)
            getData(1)
        }
    }, [props.isOpen]);

    useEffect(() => {
        return () => {
            if (filePreview) {
                URL.revokeObjectURL(filePreview);
            }
        };
    }, [filePreview]);

    const getData = (page)=>{
        setLoading(true)
        loadGallery(page).then(data => {
            if (data && data.count) {
                setGalleryCount(data.count)
                var page_count = data.count % 12 === 0 ? parseInt(data.count / 12) : parseInt(data.count / 12) + 1;
                var pages_array = range(1, page_count);
                setGalleryPages(pages_array);
            }
            if (data.results)
                setGalleryImages(data.results)
            setLoading(false)
        })
    }

    function range(start, end) {
        return Array.apply(0, Array(end))
            .map((element, index) => index + start);
    }

    const handleFileChange = (e) => {
        var file = e.target.files[0]
        if (e.target.files)
            setFile(file)
        if (file) {
            const defaultTitle = file.name.replace(/\.[^/.]+$/, '');
            setTitle(defaultTitle);
            if (filePreview) {
                URL.revokeObjectURL(filePreview);
            }
            setFilePreview(URL.createObjectURL(file));
        }

    }
    const clearSelectedFile = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (filePreview) {
            URL.revokeObjectURL(filePreview);
        }
        setFilePreview(null);
        setFile(null);
        setTitle("");
        if (inputFileRef.current) {
            inputFileRef.current.value = '';
        }
    };
    const handleChange = (e) => {
        setTitle(e.target.value)

    }

    const uploadToGallery = () => {
        setError(false)
        if (!title) {
            setError("Please Enter Name")
            return;
        }
        if (!file) {
            setError("Please Select an image")
            return;
        }

        setLoading(true)
        SaveGallery(title, file).then(data => {
            setLoading(false)
            if (data.image) {
                setUploadedImage(data)
                setTitle("")
                setFile(null)
                if (filePreview) {
                    URL.revokeObjectURL(filePreview);
                }
                setFilePreview(null)
                if (inputFileRef.current) {
                    inputFileRef.current.value = '';
                }
                setActiveTab('images')
                getData(1)
            }
        })

    }
    const closeGallery = () => {
        setGalleryModalIsOpen(false)
        props.closeGallery()
    }
    const loadPage = (e,page) => {
        e.preventDefault()
        setPage(page)
        getData(page)
    }
    
    const setSelectedImageGallery=(gallery_item)=>{
        if(props.setSelectedGalleryItem){
            props.setSelectedGalleryItem(gallery_item)
        }

        if(props.onImageSelected){
            props.onImageSelected(gallery_item.image)
        }

        closeGallery()
    }

    const deleteGalleryItem = (e,gallery_id) => {
        e.preventDefault()
        setDeleteLoading(gallery_id)
        deleteGallery(gallery_id).then(()=>{
            getData(page)
        })

        return 
    }
    

    return (


        <ReactModal
            closeTimeoutMS={500}
            isOpen={gallery_modal_is_open}
            onRequestClose={closeGallery}
            shouldCloseOnOverlayClick={true}
            shouldCloseOnEsc={true}
            className="Modal Modal--cms-gallery"
            ariaHideApp={false}
            overlayClassName="Overlay Overlay--cms-gallery"
            style={{
                overlay: { zIndex: 2000 },
                content: { zIndex: 2001, width: '95%', maxWidth: '1400px', inset: '50% auto auto 50%', transform: 'translate(-50%, -50%)' }
            }}
        >
            <div className="modal-content cms-gallery-modal-content">
                
                <div className="modal-body gallery padding-0 cms-gallery-modal-body">
                    {/* <button type="button" className="close gallery-close cms-gallery-close" onClick={closeGallery}>
                        <span aria-hidden="true">&times;</span>
                    </button> */}
                    
                    <div className="cms-gallery-shell">
                        <div className="cms-gallery-topbar">
                            <div className="cms-gallery-tabs" role="tablist" aria-label="Gallery tabs">
                                <button
                                    type="button"
                                    className={`cms-gallery-tab-btn ${activeTab === 'images' ? 'active' : ''}`}
                                    onClick={() => setActiveTab('images')}
                                >
                                    <i className="fa fa-th-large margin-r-5"></i>
                                    Select Image
                                </button>
                                <button
                                    type="button"
                                    className={`cms-gallery-tab-btn ${activeTab === 'upload' ? 'active' : ''}`}
                                    onClick={() => setActiveTab('upload')}
                                >
                                    <i className="fa fa-upload margin-r-5"></i>
                                    Upload
                                </button>
                            </div>
                        </div>

                        <div className="cms-gallery-tab-content">
                            <div className={`tab-pane ${activeTab === 'images' ? 'active' : ''}`} id="images">
                                {loading && (<>
                                    <div className="gallery-loading">
                                        Please Wait...
                                    </div>

                                </>)}
                                <div className="gallery-tab cms-gallery-grid">
                                    {gallery_images && gallery_images.map(item => (
                                        <div key={item.id} className={`gallery-item cms-gallery-item ${delete_loading===item.id ? "gallery_delete_loading" : ""}`}>
                                            <button
                                                type="button"
                                                className="cms-gallery-item-open"
                                                onClick={() => { setSelectedImageGallery(item) }}
                                            >
                                                <img src={item.image} alt={item.title || 'gallery image'} />
                                            </button>
                                            <button
                                                type="button"
                                                className="btn-gallery-delete"
                                                onClick={(e) => { if (window.confirm('Are you sure you wish to delete this item?')) deleteGalleryItem(e,item.id)}}
                                            >
                                                <i className="fa fa-trash"></i>
                                            </button>
                                            <div className="cms-gallery-item-meta">
                                                <span>{item.title || `Image #${item.id}`}</span>
                                            </div>
                                        </div>
                                        
                                    ))}
                                    <div className="clear"></div>
                                </div>
                                
                                <ul className="pagination cms-pagination m-0 float-right">
                                    {gallery_pages && gallery_pages.map((page_number) => (
                                        <li key={page_number} className="page-item">
                                            <a className={page_number === page ? "page-link active" : "page-link"}
                                                href="#loadpage" onClick={(e) => { loadPage(e, page_number) }}>{page_number}</a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <div className={`tab-pane ${activeTab === 'upload' ? 'active' : ''}`} id="upload">
                                <div className="gallery-upload cms-gallery-upload-panel">
                                    <div className="cms-gallery-upload-stack">
                                        <label className="cms-gallery-dropzone">
                                            <input type="file" ref={inputFileRef} onChange={handleFileChange} className="hide" />
                                            {filePreview ? (
                                                <>
                                                    <img src={filePreview} alt="Selected file preview" className="cms-gallery-dropzone-preview" />
                                                    <button
                                                        type="button"
                                                        className="cms-gallery-dropzone-clear"
                                                        onClick={clearSelectedFile}
                                                        title="Remove selected image"
                                                    >
                                                        <i className="fa fa-trash"></i>
                                                    </button>
                                                </>
                                            ) : (
                                                <>
                                                    <i className="fa fa-cloud-upload"></i>
                                                    <span>Click or drag file here to upload</span>
                                                    <small>Supports: JPG, PNG, GIF, WEBP</small>
                                                </>
                                            )}
                                        </label>
                                        <input type="text" value={title ?? ""} placeholder="Image name" onChange={handleChange} className="form-control cms-gallery-input" />
                                        <button type="button" className="btn btn-cm" onClick={uploadToGallery}>
                                            <i className="fa fa-cloud-upload margin-r-5"></i>
                                            Upload
                                        </button>
                                    </div>
                                </div>
                                {error &&
                                    <div className="error">
                                        {error}
                                    </div>
                                }
                                {loading && (<>
                                    <div className="gallery-loading">
                                        Please Wait...
                                    </div>

                                </>)}
                            </div>

                        </div>
                    </div>


                </div>

            </div>
        </ReactModal>

    )
}
